export default class TokenStore {
  static get apiToken() {
    const fromBodyTag = document.body.getAttribute('data-thunder')
    const fromSessionStorage = sessionStorage.getItem('unexpected_thunder');

    return fromBodyTag || fromSessionStorage || '';
  }
}
